module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAbCAYAAACqenW9AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QoKCA0N8c3JCgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAACuSURBVDjL7dEhUkMxFIXh78VgGEwlw11AXZcSh6ztirqE4rIOVB0LuG/YAYZnHibMIIAGg+pvIvLfTM6507quq0GKP3CVr/L/y1O0kDVFixs84oAdzjjiKWu+RwsTRIsHvOD2mwffsM2a8xQt7vD6g/h14L6gXhD1+1r6H0c4lB5mhF3pqUc4l17PCMeCU0/rQhunkjUXbH8Z+Ox5KX2DMzbY4xlLP/fYZM05WvgAk1YzlbCdE8AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticket_top_circle.png
// module id = R0tX
// module chunks = 1